import styled from "styled-components";

export const WholeWrapper = styled.div`
  width: 21.2rem;
  height: 10.4rem;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4.8rem;
`;
